import useTabVisibility from '../../hooks/useTabVisibility';
import { useEffect } from 'react';
import { useEffectEvent } from '../../hooks/useEffectEvent';

export const usePauseOnBackground = ({
  seekVideo,
  getStartTime,
  isPlaying,
  togglePlay,
  enabled,
  savedTime,
}: {
  seekVideo: (time: number) => void;
  getStartTime?: () => number | undefined;
  isPlaying: boolean;
  togglePlay: () => void;
  enabled: boolean;
  savedTime?: number;
}): void => {
  const isTabVisible = useTabVisibility();

  const handleVisibilityChange = useEffectEvent(async () => {
    if (isTabVisible && !isPlaying) {
      togglePlay();

      const startTime = getStartTime ? getStartTime() || 0 : 0;
      const timeToSeek = Math.max(startTime, savedTime ?? 0);
      if (startTime > 0) seekVideo(timeToSeek);
    }

    if (!isTabVisible && isPlaying) {
      togglePlay();
    }
  });

  useEffect(() => {
    if (enabled) handleVisibilityChange();
  }, [enabled, handleVisibilityChange, isTabVisible]);
};
